
      var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThumbUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56.77 46.34c3.654 12.56 16.973 15.942 24.145 15.942v37.639c0 2.091-29.276 8.365-37.641 8.365-6.692 0-11.153-2.789-12.547-4.183-1.394-5.576-5.41-19.552-8.364-31.367-4.183-16.73 12.546-14.638 20.911-14.638 0-3.92.207-11.012.911-16.04.463-3.3 2.156-6.43 5.081-8.026 1.099-.6 2.008-.757 2.788-.536 4.55 1.29 3.394 8.302 4.715 12.843Z",
  fill: "var(--theme-light,#e2cff7)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M99 110.004H80.402a2.832 2.832 0 0 1-2.822-2.841V58.807a2.831 2.831 0 0 1 2.822-2.84H99a2.832 2.832 0 0 1 2.822 2.84v48.356A2.832 2.832 0 0 1 99 110.004Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M83.231 104.321h12.953V61.647H83.231v42.674Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m64.5 29.5 8.5-5M37.5 29.5l-8.5-5M51.25 21.861 51.33 12",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M56.7695 46.3394C60.424 58.9006 73.7434 62.282 80.9147 62.282V99.9209C80.9147 102.012 51.6387 108.286 43.274 108.286C36.5823 108.286 32.1213 105.497 30.7272 104.103C29.3331 98.5268 25.3163 84.5514 22.3626 72.736C18.1805 56.0068 34.9094 58.098 43.274 58.098C43.274 54.1771 43.4808 47.0855 44.1853 42.0578C44.6476 38.7581 46.3413 35.6275 49.2664 34.0319C50.3649 33.4327 51.2735 33.2745 52.0537 33.4956C56.6038 34.7851 55.4484 41.7985 56.7695 46.3394Z\" fill=\"var(--theme-light,#e2cff7)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\"/>\r\n<path d=\"M98.9997 110.004H80.4022C78.8436 110.004 77.5801 108.732 77.5801 107.163V58.8074C77.5801 57.2386 78.8436 55.9668 80.4022 55.9668H98.9997C100.558 55.9668 101.822 57.2386 101.822 58.8074V107.163C101.822 108.732 100.558 110.004 98.9997 110.004Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M83.2312 104.321H96.1844V61.6465H83.2312V104.321Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M64.4993 29.5L72.9993 24.5\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n<path d=\"M37.4993 29.5L28.9993 24.5\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n<path d=\"M51.2492 21.8612L51.3293 12\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/thumbUp.62a07880a5450c1c80111a53ba3c56a8.svg"),
        {
          React: SvgThumbUp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      